import { render, staticRenderFns } from "./appReviews.vue?vue&type=template&id=955f33dc&scoped=true"
import script from "./appReviews.vue?vue&type=script&lang=js"
export * from "./appReviews.vue?vue&type=script&lang=js"
import style0 from "./appReviews.vue?vue&type=style&index=0&id=955f33dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f33dc",
  null
  
)

export default component.exports